import ActionType from 'store/_utils/classes/ActionType';

import type IActionType from 'store/_utils/interfaces/IActionType';

class MessagingInternalTypes {
  static getMessages: IActionType = new ActionType('IMESSAGE/GET_MESSAGES');
  static getChats: IActionType = new ActionType('IMESSAGE/GET_CHATS');
  static getMessagesChat: IActionType = new ActionType('IMESSAGE/GET_MESSAGES_CHAT');
  static sendMessageChat: IActionType = new ActionType('IMESSAGE/SEND_MESSAGE_CHAT');
  static listProducts: IActionType = new ActionType('IMESSAGE/LIST_PRODUCT');
  static getAffiliates: IActionType = new ActionType('IMESSAGE/GET_AFFILIATES');
  static sendMessageBroadcast: IActionType = new ActionType('IMESSAGE/SEND_MESSAGE_BROADCAST');
}

export default MessagingInternalTypes;
